import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_ESENCIAL } from '../lib/links';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-158" data-mp="1v8312h355ckj">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-forest/12 bg-cream-card/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-159" data-mp="1v71t4lhf9671">
          <div className="flex items-center gap-3" data-id="element-160" data-mp="2dyuj07172baj">
            <div className="min-w-0 flex-1" data-id="element-161" data-mp="2dzm4uq4zounm">
              <p className="truncate text-xs text-forest-dark/55" data-id="element-162" data-mp="3fb87yxxz8jpa">
                Mega Pack · 3 Tomos + 6 Bonos
              </p>
              <p className="font-display text-lg font-semibold text-forest-dark" data-id="element-163" data-mp="3adzn2plg21kc">
                $19.990 ARS
              </p>
            </div>
            <a href={CHECKOUT_ESENCIAL} target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-forest px-5 py-3 text-sm font-semibold text-cream transition-colors hover:bg-forest-dark" data-id="element-164" data-mp="3p3dw1wl3ygz7">
              Comprar
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="bvaxsoztfbqy" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}